module.exports = __webpack_public_path__ + "static/media/1-F-mobile.5f61b97e.webp";